<template>
  <div class="chengelog mx-auto container">
    <!-- <div class="Guides__container position-absolute">
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
      <div class="Guides__guide"></div>
    </div> -->
    <section class="header mb-5 text-center">
      <h3 class="mdc-typography--headline3">{{ $t('hero_title') }}</h3>
      <p class="mdc-typography--headline6">
        {{ $t('hero_subtitle') }}
      </p>
      <!-- <img class="profile-picture" src="/img/changelog/mateesville.jpg" /> -->
    </section>

    <article
      class="article-content"
      v-for="item in items.slice().reverse()"
      :key="item.id"
    >
      <!-- <div class="Guides__container position-absolute">
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
        <div class="Guides__guide"></div>
      </div> -->
      <aside class="update-version">
        <div class="sticky-top pl-3">
          <h2 class="version">
            {{ $t('version') }}
            <strong class="text-mono">{{ item.version }}</strong>
          </h2>
          <p>
            {{ $t('date_release') }} <strong>{{ item.release_date }}</strong>
          </p>
          <hr class="mt-1" />
          <h6>
            {{ $t('developers') }}
            <span class="badge badge-light ml-2">1</span>
          </h6>
          <dd>
            <a
              href="https://www.github.com/mateesville93"
              target="_blank"
              rel="noopener"
              >Bogdan Mateescu</a
            >
          </dd>
          <hr class="mt-1" />
          <!-- <h6>Requirements <span class="badge badge-light ml-2">18</span></h6>
          <dd>django==2.2.7</dd>
          <dd>django-environ==0.4.5</dd>
          <dd>whitenoise==4.1.4</dd>
          <dd>django-braces==1.11.0</dd>
          <dd>django-crispy-forms==1.8.0</dd>
          <dd>django-widget-tweaks</dd>
          <dd>django-model-utils==3.2.0</dd> -->
        </div>
      </aside>
      <picture>
        <source
          v-bind:srcset="
            '/img/changelog/' +
              item.image_src_small +
              '.webp 320w,' +
              '/img/changelog/' +
              item.image_src_medium +
              '.webp 768w,' +
              '/img/changelog/' +
              item.image_src_large +
              '.webp 1024w,' +
              '/img/changelog/' +
              item.image_src_large +
              '.webp 1440w'
          "
          type="image/webp"
        />
        <source
          v-bind:srcset="
            '/img/changelog/' +
              item.image_src_small +
              '.jpg 320w,' +
              '/img/changelog/' +
              item.image_src_medium +
              '.jpg 768w,' +
              '/img/changelog/' +
              item.image_src_large +
              '.jpg 1024w,' +
              '/img/changelog/' +
              item.image_src_large +
              '.jpg 1440w'
          "
          type="image/jpeg"
        />
        <img
          v-bind:src="'/img/changelog/' + item.image_src + '.jpg'"
          alt="Version image"
          class="update-thumbnail"
          loading="lazy"
        />
      </picture>
      <!-- <img
        v-bind:src="'/img/changelog/' + item.image_src"
        class="update-thumbnail"
        loading="lazy"
      /> -->
      <div class="update-content">
        <h6
          class="update-features text-uppercase mdc-typography--headline6 d-flex align-items-center"
        >
          <i class="material-icons mr-2"> new_releases </i>New Features
        </h6>
        <ol class="text-mono">
          <li v-for="item in item.features" :key="item.id">
            {{ item.feature }}
          </li>
        </ol>
        <h6
          class="update-fixes text-uppercase mdc-typography--headline6 d-flex align-items-center"
        >
          <i class="material-icons mr-2">
            construction
          </i>
          Fixes and Updates
        </h6>
        <ul class="text-mono">
          <li v-for="item in item.fixes" :key="item.id">{{ item.fix }}</li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Changelog',
  metaInfo() {
    return {
      title: this.$t('page_title') || 'Default',
      titleTemplate: '%s | Surfverse',
      meta: [{ name: 'description', content: this.$t('page_description') }]
    }
  },
  data: function() {
    return {
      items: [
        {
          version: this.$t('commit1.version'),
          sha: this.$t('commit1.sha'),
          title: this.$t('commit1.title'),
          release_date: this.$t('commit1.release_date'),
          image_src: 'v1',
          image_src_small: 'v1-small',
          image_src_medium: 'v1-medium',
          image_src_large: 'v1-large',
          feature_title: this.$t('commit1.feature_title'),
          features: [
            { feature: this.$t('commit1.features.item1') },
            { feature: this.$t('commit1.features.item2') },
            { feature: this.$t('commit1.features.item3') }
          ],
          fixes: [{ fix: this.$t('commit1.fixes.fix1') }]
        },
        {
          version: this.$t('commit2.version'),
          sha: this.$t('commit2.sha'),
          title: this.$t('commit2.title'),
          release_date: this.$t('commit2.release_date'),
          image_src: 'v2',
          image_src_small: 'v2-small',
          image_src_medium: 'v2-medium',
          image_src_large: 'v2-large',
          feature_title: this.$t('commit2.feature_title'),
          features: [
            { feature: this.$t('commit2.features.item1') },
            { feature: this.$t('commit2.features.item2') },
            { feature: this.$t('commit2.features.item3') },
            { feature: this.$t('commit2.features.item4') },
            { feature: this.$t('commit2.features.item5') },
            { feature: this.$t('commit2.features.item6') },
            { feature: this.$t('commit2.features.item7') },
            { feature: this.$t('commit2.features.item8') },
            { feature: this.$t('commit2.features.item9') },
            { feature: this.$t('commit2.features.item10') },
            { feature: this.$t('commit2.features.item11') },
            { feature: this.$t('commit2.features.item12') },
            { feature: this.$t('commit2.features.item13') },
            { feature: this.$t('commit2.features.item14') },
            { feature: this.$t('commit2.features.item15') }
          ],
          fixes: [
            { fix: this.$t('commit2.fixes.fix1') },
            { fix: this.$t('commit2.fixes.fix2') },
            { fix: this.$t('commit2.fixes.fix3') },
            { fix: this.$t('commit2.fixes.fix4') },
            { fix: this.$t('commit2.fixes.fix5') },
            { fix: this.$t('commit2.fixes.fix6') },
            { fix: this.$t('commit2.fixes.fix7') }
          ]
        },
        {
          version: this.$t('commit3.version'),
          sha: this.$t('commit3.sha'),
          title: this.$t('commit3.title'),
          release_date: this.$t('commit3.release_date'),
          image_src: 'v3',
          image_src_small: 'v3-small',
          image_src_medium: 'v3-medium',
          image_src_large: 'v3-large',
          feature_title: this.$t('commit3.feature_title'),
          features: [
            { feature: this.$t('commit3.features.item1') },
            { feature: this.$t('commit3.features.item2') },
            { feature: this.$t('commit3.features.item3') },
            { feature: this.$t('commit3.features.item4') },
            { feature: this.$t('commit3.features.item5') },
            { feature: this.$t('commit3.features.item6') },
            { feature: this.$t('commit3.features.item7') }
          ],
          fixes: [
            { fix: this.$t('commit3.fixes.fix1') },
            { fix: this.$t('commit3.fixes.fix2') },
            { fix: this.$t('commit3.fixes.fix3') },
            { fix: this.$t('commit3.fixes.fix4') },
            { fix: this.$t('commit3.fixes.fix5') },
            { fix: this.$t('commit3.fixes.fix6') },
            { fix: this.$t('commit3.fixes.fix7') },
            { fix: this.$t('commit3.fixes.fix8') }
          ]
        },
        {
          version: this.$t('commit4.version'),
          sha: this.$t('commit4.sha'),
          title: this.$t('commit4.title'),
          release_date: this.$t('commit4.release_date'),
          image_src: 'v4',
          image_src_small: 'v4-small',
          image_src_medium: 'v4-medium',
          image_src_large: 'v4-large',
          feature_title: this.$t('commit4.feature_title'),
          features: [
            { feature: this.$t('commit4.features.item1') },
            { feature: this.$t('commit4.features.item2') },
            { feature: this.$t('commit4.features.item3') },
            { feature: this.$t('commit4.features.item4') },
            { feature: this.$t('commit4.features.item5') },
            { feature: this.$t('commit4.features.item6') },
            { feature: this.$t('commit4.features.item7') },
            { feature: this.$t('commit4.features.item8') },
            { feature: this.$t('commit4.features.item9') }
          ],
          fixes: [
            { fix: this.$t('commit4.fixes.fix1') },
            { fix: this.$t('commit4.fixes.fix2') },
            { fix: this.$t('commit4.fixes.fix3') }
          ]
        },
        {
          version: this.$t('commit5.version'),
          sha: this.$t('commit5.sha'),
          title: this.$t('commit5.title'),
          release_date: this.$t('commit5.release_date'),
          features: 'Requirements.txt',
          fixes: 'Fixes',
          image_src: 'v5',
          image_src_small: 'v5-small',
          image_src_medium: 'v5-medium',
          image_src_large: 'v5-large',
          feature_title: this.$t('commit5.feature_title'),
          features: [
            { feature: this.$t('commit5.features.item1') },
            { feature: this.$t('commit5.features.item2') },
            { feature: this.$t('commit5.features.item3') },
            { feature: this.$t('commit5.features.item4') },
            { feature: this.$t('commit5.features.item5') }
          ],
          fixes: [{ fix: this.$t('commit5.fixes.fix1') }]
        },
        {
          version: this.$t('commit6.version'),
          sha: this.$t('commit6.sha'),
          title: this.$t('commit6.title'),
          release_date: this.$t('commit6.release_date'),
          image_src: 'v6',
          image_src_small: 'v6-small',
          image_src_medium: 'v6-medium',
          image_src_large: 'v6-large',
          feature_title: this.$t('commit6.feature_title'),
          features: [
            { feature: this.$t('commit6.features.item1') },
            { feature: this.$t('commit6.features.item2') }
          ],
          fixes: [
            { fix: this.$t('commit6.fixes.fix1') },
            { fix: this.$t('commit6.fixes.fix2') }
          ]
        },
        {
          version: this.$t('commit7.version'),
          sha: this.$t('commit7.sha'),
          title: this.$t('commit7.title'),
          release_date: this.$t('commit7.release_date'),
          image_src: 'v7',
          image_src_small: 'v9-small',
          image_src_medium: 'v9-medium',
          image_src_large: 'v9-large',
          feature_title: this.$t('commit7.feature_title'),
          features: [
            { feature: this.$t('commit7.features.item1') },
            { feature: this.$t('commit7.features.item2') },
            { feature: this.$t('commit7.features.item3') },
            { feature: this.$t('commit7.features.item4') }
          ],
          fixes: [
            { fix: this.$t('commit7.fixes.fix1') },
            { fix: this.$t('commit7.fixes.fix2') },
            { fix: this.$t('commit7.fixes.fix3') },
            { fix: this.$t('commit7.fixes.fix4') },
            { fix: this.$t('commit7.fixes.fix5') }
          ]
        },
        {
          version: this.$t('commit8.version'),
          sha: this.$t('commit8.sha'),
          title: this.$t('commit8.title'),
          release_date: this.$t('commit8.release_date'),
          image_src: 'v8',
          image_src_small: 'v11-small',
          image_src_medium: 'v11-medium',
          image_src_large: 'v11-large',
          feature_title: this.$t('commit8.feature_title'),
          features: [
            { feature: this.$t('commit8.features.item1') },
            { feature: this.$t('commit8.features.item2') },
            { feature: this.$t('commit8.features.item3') },
            { feature: this.$t('commit8.features.item4') },
            { feature: this.$t('commit8.features.item5') },
            { feature: this.$t('commit8.features.item6') },
            { feature: this.$t('commit8.features.item7') }
          ],
          fixes: [
            { fix: this.$t('commit8.fixes.fix1') },
            { fix: this.$t('commit8.fixes.fix2') }
          ]
        },
        {
          version: this.$t('commit9.version'),
          sha: this.$t('commit9.sha'),
          title: this.$t('commit9.title'),
          release_date: this.$t('commit9.release_date'),
          image_src: 'v9',
          image_src_small: 'v10-small',
          image_src_medium: 'v10-medium',
          image_src_large: 'v10-large',
          feature_title: this.$t('commit9.feature_title'),
          features: [
            { feature: this.$t('commit9.features.item1') },
            { feature: this.$t('commit9.features.item2') },
            { feature: this.$t('commit9.features.item3') },
            { feature: this.$t('commit9.features.item4') },
            { feature: this.$t('commit9.features.item5') },
            { feature: this.$t('commit9.features.item6') }
          ],
          fixes: [
            { fix: this.$t('commit9.fixes.fix1') },
            { fix: this.$t('commit9.fixes.fix2') },
            { fix: this.$t('commit9.fixes.fix3') },
            { fix: this.$t('commit9.fixes.fix4') }
          ]
        },
        {
          version: this.$t('commit10.version'),
          sha: this.$t('commit10.sha'),
          title: this.$t('commit10.title'),
          release_date: this.$t('commit10.release_date'),
          image_src: 'v10',
          image_src_small: 'v12-small',
          image_src_medium: 'v12-medium',
          image_src_large: 'v12-large',
          feature_title: this.$t('commit10.feature_title'),
          features: [
            { feature: this.$t('commit10.features.item1') },
            { feature: this.$t('commit10.features.item2') },
            { feature: this.$t('commit10.features.item3') },
            { feature: this.$t('commit10.features.item4') },
            { feature: this.$t('commit10.features.item5') },
            { feature: this.$t('commit10.features.item6') }
          ],
          fixes: [
            { fix: this.$t('commit10.fixes.fix1') },
            { fix: this.$t('commit10.fixes.fix2') },
            { fix: this.$t('commit10.fixes.fix3') },
            { fix: this.$t('commit10.fixes.fix4') },
            { fix: this.$t('commit10.fixes.fix5') }
          ]
        }
      ]
    }
  }
}
</script>

<i18n>
{
  "en": {
    "page_title": "Changelog",
    "page_description": "Get to know the latest feature updates and improvements to Surfverse.com",
    "hero_title": "What's New",
    "hero_subtitle": "Get to know the latest feature updates and improvements to Surfverse.com",
    "version": "Version",
    "date_release": "Released on",
    "developers": "Developers",
    "commit1": {
      "version": "0.1.0",
      "sha": "c2341c39",
      "title": "Init commit",
      "release_date": "30.08.2017",
      "feature_title": "Features",
      "features": {
        "item1": "Creating Azure DevOps formerly (VSTS) Organization + Git Repo for Surfverse_Project",
        "item2": "Choosing the Tech Stack: Python + Django for Backend and PolymerJS for Frontend at that time",
        "item3": "Starting with pydanny/cookiecutter-django as a starter-kit. Django Version: django==1.10.7"
      },
      "fixes": {
        "fix1": "Fix GraphQL schema"
      }
    },
    "commit2": {
      "version": "0.1.1",
      "sha": "c2341c39",
      "title": "Cumulative update for September",
      "release_date": "01.10.2017",
      "feature_title": "Features",
      "features": {
        "item1": "i18n + l10n. Preparing the software for localization.",
        "item2": "Added django REST framework to requirements",
        "item3": "Added django-oauth-toolkit",
        "item4": "Extend Django User Model with new fields",
        "item5": "New layout using polymerjs and webcomponents",
        "item6": "User Preferences",
        "item7": "New frontend service based on prpl-server-node",
        "item8": "Added Flatpages for static pages",
        "item9": "Added bootstrap4 templates from django-crispy-forms",
        "item10": "Added TimeStampedModel to core + utils.py",
        "item11": "Moved countries, langs, timezones to Core app",
        "item12": "New Rest Framework interface",
        "item13": "Added Django-hosts for api endpoint",
        "item14": "Added graph endpoint subdomain in django-hosts",
        "item15": "New API's endpoint subdomain + redesigned layout"
      },
      "fixes": {
        "fix1": "Fix for local translation",
        "fix2": "Updated two_factor_auth templates",
        "fix3": "Updated user_sessions templates",
        "fix4": "Minor fix of authorized template",
        "fix5": "Fix pytest import and and Users dinamic Following Field",
        "fix6": "Fix for loading Fixtures",
        "fix7": "Redesign Compose folder"
      }
    },
    "commit3": {
      "version": "0.1.2",
      "sha": "c2341c39",
      "title": "Cumulative update for October",
      "release_date": "01.11.2017",
      "feature_title": "Features",
      "features": {
        "item1": "New Two Factor Authentication for Account Security",
        "item2": "New GraphQL and REST endpoints based on django-graphene",
        "item3": "Moved countries, langs, timezones to Core app",
        "item4": "New subdomain for accounts settings",
        "item5": "New users list",
        "item6": "Added Django Content Security Policy",
        "item7": "New templates for company presentation"
      },
      "fixes": {
        "fix1": "Updated local and production compose file + some templates from DRF",
        "fix2": "Remove is_verified field from users",
        "fix3": "Updated structure for api's + graph and new permissions",
        "fix4": "Fix graph authentication problem",
        "fix5": "Docs for Hosts conf file for win10.",
        "fix6": "Update for requirements.txt",
        "fix7": "Removed React frontend and bower, we will add material design.",
        "fix8": "Fix some colors on graphql template"
      }
    },
    "commit4": {
      "version": "0.1.3",
      "sha": "c2341c39",
      "title": "Cumulative update for November",
      "release_date": "01.12.2017",
      "feature_title": "Features",
      "features": {
        "item1": "Implementing django-allauth + django-allauth-2fa",
        "item2": "New design for 2FA and allauth templates + push translation to Transifex",
        "item3": "Moved countries, langs, timezones to Core app",
        "item4": "New Users Profiles",
        "item5": "New Search Box",
        "item6": "Now non loged in users can access other users profile and users list",
        "item7": "Improved login and signup flow + check username availability while type.",
        "item8": "Now can Login or Signup with one click using Facebook, Twitter, Google, Github and Microsoft",
        "item9": "New Ckeditor for Profile Bio"
      },
      "fixes": {
        "fix1": "Add session_cookie_domain for sso across subdomains",
        "fix2": "Commit db739cd8: fix for post.pk|unlocalize for subscriptions",
        "fix3": "New humanize filter for datetime"
      }
    },
    "commit5": {
      "version": "0.1.4",
      "sha": "c2341c39",
      "title": "New Profile Layout",
      "release_date": "01.02.2018",
      "feature_title": "New Features",
      "features": {
        "item1": "Now users can activate Two Factor Authentication for their accounts",
        "item2": "New GraphQL and REST endpoints based on django-graphene",
        "item3": "Added Caddy service to proxy django service",
        "item4": "New Authentication experience",
        "item5": "Added Rosetta for translation"
      },
      "fixes": {
        "fix1": "Update to django==2.0.2"
      }
    },
    "commit6": {
      "version": "0.1.5",
      "sha": "c2341c39",
      "title": "Material Design for Web",
      "release_date": "01.04.2019",
      "feature_title": "New Features",
      "features": {
        "item1": "Material Design for web",
        "item2": "Switch to Dark Mode"
      },
      "fixes": {
        "fix1": "Fix for session_cookie to work with ngrok",
        "fix2": "Update for django-crispy-forms"
      }
    },
    "commit7": {
      "version": "0.1.6",
      "sha": "c2341c39",
      "title": "Containers Orchestration",
      "release_date": "01.06.2019",
      "feature_title": "New Features",
      "features": {
        "item1": "Now Users can follow other people",
        "item2": "Now Users can post articles",
        "item3": "Added Documentation for our REST Api",
        "item4": "Now Users can perform CRUD on posts"
      },
      "fixes": {
        "fix1": "Update for snackbar when user make an actions",
        "fix2": "Fix rest api user-detail, group-detail urls",
        "fix3": "Updated Following System",
        "fix4": "Fix button for is_following exception",
        "fix5": "Fix for follow button toggle text works with i18n"
      }
    },
    "commit8": {
      "version": "0.1.7",
      "sha": "c2341c39",
      "title": "Profiles Updates",
      "release_date": "01.07.2019",
      "feature_title": "New Features",
      "features": {
        "item1": "Now Users can see others liked posts",
        "item2": "GraphQL endpoint now can fetch Posts, Comments, Likes",
        "item3": "Now users can see followers they already follow on others profile",
        "item4": "New Badge for Verified Users",
        "item5": "Profiles now display number of followers, following and posts",
        "item6": "Now User Avatar has a green border which pulse when they have activity on their account on the last week",
        "item7": "Now we parse user bio and highlight @usernames"
      },
      "fixes": {
        "fix1": "Security fix for XSS vulnerability on user_bio field",
        "fix2": "We start working on messages app with django-channels"
      }
    },
    "commit9": {
      "version": "0.1.8",
      "sha": "c2341c39",
      "title": "Searching",
      "release_date": "01.09.2019",
      "feature_title": "New Features",
      "features": {
        "item1": "Added support for Algolia Search",
        "item2": "Now can search by voice in almost all supported django languages",
        "item3": "Indexing Users, Companies, Startups and Posts",
        "item4": "Working on AutoComplete box",
        "item5": "Users List has new layout and filters",
        "item6": "Working on Search by Color and Images"
      },
      "fixes": {
        "fix1": "Cleaning some unused files",
        "fix2": "Fix for login layout",
        "fix3": "Fix for Like and Follow button",
        "fix4": "Fix for profiles when users do not have a name, displaying username instead"
      }
    },
    "commit10": {
      "version": "0.2.1",
      "sha": "c2341c39",
      "title": "Profiles",
      "release_date": "01.11.2019",
      "feature_title": "New Features",
      "features": {
        "item1": "Displaying user last week activity",
        "item2": "Subscriptions now list a feed with the activity of a user's following list",
        "item3": "New design for subscriptions posts cards",
        "item4": "Display Groups that user belong in user profile",
        "item5": "Users List has new layout and filters",
        "item6": "Added is_verified field to user and change the max length of username to 30 chars",
        "item6": "Infinite scroll on user list but still need attention",
        "item6": "New shared paginator"
      },
      "fixes": {
        "fix1": "Fix for comment box",
        "fix2": "Fix for posts datetime",
        "fix3": "Improved followers you follow on user profile",
        "fix4": "Hover for like heart color and updated posts last week to use isocalendar",
        "fix5": "Performance improvements"
      }
    }
  },
  "ro": {
    "page_title": "Jurnal actualizări",
    "page_description": "Vedeți jurnalul celor mai recente actualizări ale caracteristicilor și îmbunătățiri aduse pe Surfverse.com",
    "hero_title": "Ce mai e nou",
    "hero_subtitle": "Vedeți jurnalul celor mai recente actualizări ale caracteristicilor și îmbunătățiri aduse pe Surfverse.com",
    "version": "Versiune",
    "date_release": "Lansată la",
    "developers": "Dezvoltatori"
  }
}
</i18n>

<style>
h2.version:before {
  position: absolute;
  top: 12.3%;
  left: -7px;
  z-index: 10;
  display: block;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  margin-top: -6px;
  content: ' ';
  background-color: #e1e4e8;
  border: 2px solid #212121;
  border-radius: 6px;
}
.sticky-top {
  top: 76px !important;
}
.profile-picture {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-left: -40px;
  border: 1px dashed;
}
.header {
  margin-top: 150px;
  margin-bottom: 80px;
}
article {
  background: transparent;
}
.article-content {
  margin: 0px auto;
  display: grid;
  grid-template-columns: 15rem 1fr;
  grid-template-areas:
    'aside img'
    '. content';
  column-gap: 2rem;
  padding: 4rem 0px 2rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 2px solid rgba(0, 0, 0, 0.1);
}
.update-version {
  font-size: 1rem;
  font-stretch: normal;
  font-style: normal;
  font-variant-caps: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 4rem 0px 0px;
  grid-area: aside / aside / content / aside;
}
.sticky-top > h2 {
  border-bottom: 12px solid;
}
.update-features:after {
  background-color: #00a15f;
}
.update-fixes:after {
  background-color: #ffba30;
}
.update-features {
  color: #00a15f;
}
.update-fixes {
  color: #ffba30;
}
.update-features,
.update-fixes {
  line-height: 20px;
  font-size: 16px;
  font-weight: 700;
}
.update-features:after,
.update-fixes:after {
  content: '';
  height: 5px;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-left: 4px;
  opacity: 0.6;
}
.update-thumbnail {
  margin-bottom: 2rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  grid-area: img / img / img / img;
  clip-path: inset(0px round 0.5rem);
}
.update-content {
  font-size: 1.1rem;
  line-height: 1.6rem;
  font-weight: 300;
  margin-top: 1.8em;
  margin-bottom: 2rem;
  grid-area: content / content / content / content;
}
.update-content > ol li:before {
  content: '+ ';
  font-weight: 600;
  color: #1b1;
  font-size: 19px;
  width: 10px;
  height: 10px;
  top: -1px;
  left: 5px;
  position: absolute;
}
.update-content > ul li:before {
  content: ' ';
  background-image: url("data:image/svg+xml;utf8,<svg width='15' height='11' viewBox='0 0 15 11' xmlns='http://www.w3.org/2000/svg'><path id='mask' d='M2 6l3.5 3.5L13 2' stroke-width='2' stroke='%236cc7f6'  fill='none' stroke-linecap='round'/></svg>");
  height: 11px;
  width: 15px;
  left: 2px;
  top: 10px;
  position: absolute;
}
.update-content > ul,
.update-content ol {
  padding: 0px;
  margin: 1rem 0px 3rem;
}
ol,
ul {
  padding: 0;
  margin: 0 0 1.0875rem 1.45rem;
  list-style-position: outside;
  list-style-image: none;
}
.update-content > ul li,
.update-content ol li {
  list-style: none;
  line-height: 2rem;
  padding: 0px 0px 0px 2rem;
  position: relative;
}
@media screen and (max-width: 768px) {
  .article-content {
    grid-template-columns: 1fr;
    grid-template-areas:
      'aside'
      'img'
      'content';
  }
  .update-version {
    margin: 0.25rem 0px 2rem;
    grid-area: aside / aside / aside / aside;
  }
  .sticky-top {
    top: 0 !important;
    position: relative;
  }
  .header {
    margin-top: 50px;
    margin-bottom: 0px;
    padding-bottom: 0px !important;
  }
  /* #app:before,
  #app:after {
    display: none;
  } */
}
</style>
